Wee.fn.make('touchSlider', {
	init: function() {
		this.$private.init();
	},

	destroy: function() {
		this.$private.destroy();
	}
}, {
	init: function() {
		var $parent = $('ref:weeTouchSlider'),
			$items = $('ref:weeTouchSliderItem'),
			$inner = $('ref:weeTouchSliderItems'),
			width = $items.width(true),
			i = 1,
			position;

		$parent.on('swipeLeft.touchSlider', function() {
			if (i !== $items.length) {
				position = -Math.abs(width * i);

				$inner.css('transform', 'translateX(' + position + 'px)');

				i++;
			}
		});

		$parent.on('swipeRight.touchSlider', function() {
			if (i > 1) {
				i--;

				position = -Math.abs(width * (i - 1));

				$inner.css('transform', 'translateX(' + position + 'px)');
			}
		});
	},

	destroy: function() {
		Wee.events.off(false, '.touchSlider');
	}
});